import styled from "styled-components";
import DiscordImg from "./img/icons8-logo-discord-30.png";
import FacebookImg from "./img/icons8-facebook-novo-30.png";
import InstagramImg from "./img/icons8-instagram-24.png";
import GoldStarImg from "./img/goldstar.png"

function FooteBan(){

    const currentYear = new Date().getFullYear();



    return(
        <FooterContainer>
		    <FirstSection>
                <LogoContainer>

                    <TitleIconContainer>
                        <LionsRagIcon img={GoldStarImg}/>
                        <LionsRagSpan>LIONSRAG</LionsRagSpan>
                    </TitleIconContainer>

                    <span>Junte-se a família LionsRag!</span>
                </LogoContainer>

                <UtilityLinksContainter>
                    <UtilityLink>Database</UtilityLink>
                    <UtilityLink>Termos de Uso</UtilityLink>
                    <UtilityLink>Criar Conta</UtilityLink>
                </UtilityLinksContainter>

                <SocialMediaContainter>
                    <MediaItemContainter>
                        <SocialMediaIcon img={DiscordImg} onClick={() => window.open('https://discord.gg/X8Z2gVQ93K', "_blank")}/>
                        <span>Discord</span>
                    </MediaItemContainter>

                    <MediaItemContainter>
                        <SocialMediaIcon img={FacebookImg} onClick={() => window.open('https://www.facebook.com/LionsRagnarok/', "_blank")}/>
                        <span>Facebook</span>
                    </MediaItemContainter>
                    

                    <MediaItemContainter>
                        <SocialMediaIcon img={InstagramImg} onClick={() => window.open('https://www.instagram.com/lionsragnarokprivate/', "_blank")}/>
                        <span>Instagram</span>
                    </MediaItemContainter>
                    
                </SocialMediaContainter>
            </FirstSection>

            <CopyRightSpan>© {currentYear} LionsRag. Todos os Direitos Reservados.<br/>
			Ragnarok Online e todos os produtos relacionados são de propriedade da Gravity e seus criadores.</CopyRightSpan>
        </FooterContainer>
    );
};

const FooterContainer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    padding: 0px 0px;
	background-color: rgb(156, 5, 5);
	opacity: 1.0;
	transition-duration: 1s;
	box-shadow: 15px -2px 7px 2px rgba(0,0,0,0.7);
    width: 100vw;
    margin: 20px 0 0px 0;
    padding: 30px 0;


`;

const CopyRightSpan = styled.span`
    font-size: 11pt;
    text-align: center;

    @media(max-width: 1000px) {
        margin-bottom: 30px;
    }

`

const FirstSection = styled.div`
    display: flex;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding: 0 0 30px 0;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
    width: 1000px;

    @media(max-width: 1000px) {
      flex-direction: column;
      margin-bottom: 30px;
    }

`

const LogoContainer = styled.div`
    display: flex;
    width: 200px;
    align-items: center;
    flex-direction: column;
    //border: solid;

    @media(max-width: 1000px) {
      margin-bottom: 30px;
    }
`

const TitleIconContainer = styled.div`
    display: flex;
    width: 200px;
    justify-content: start;
    align-items: center;
    //border: solid;
    margin-bottom: 5px;
`

const LionsRagIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    backgroun-position: center center;
    width: 30px;
    height: 30px;
    margin-bottom: 5px;
    margin-right: 10px;

`

const LionsRagSpan = styled.span`
    font-size: 18pt;
    font-weight: bold;
`

const UtilityLinksContainter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    width: 360px;

    @media(max-width: 1000px) {
      margin-bottom: 30px;
    }
`

const UtilityLink = styled.span`
    font-size: 12pt;
    //border: solid;
    padding: 10px 10px;
    border-radius: 5px;
    transition: .3s ease-in-out;

    &:hover {
        background-color: rgba(0,0,0,.3);

    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`

const SocialMediaContainter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 280px;
    
`

const MediaItemContainter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 10px;
    border-radius: 5px;
    transition: .3s ease-in-out;

    &:hover {
        background-color: rgba(0,0,0,.3);

    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`
const SocialMediaIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    backgroun-position: center center;
    width: 25px;
    height: 25px;
    margin-bottom: 5px;

`


export default FooteBan;